<template lang="pug">
  b-row.h-100
    b-col.h-100.pr-0(lg="4")
      b-card.mb-0.h-100(no-body)
        b-card-header
          b-form-row.align-items-center
            b-col.d-flex
              b-avatar.mr-2(:src="admin.image")
              .text-sm
                div {{ admin.first_name || '' }} {{ admin.last_name || '' }}
                .text-secondary {{admin.email || ''}}
            b-col(cols="auto")
              b-badge.mr-1(:variant="today_attending_cases > 0 ? 'soft-success' : 'soft-light'", pill, v-b-tooltip="'Casos en atención'") {{ today_attending_cases }}
              b-badge(:variant="today_closed_cases > 0 ? 'soft-primary' : 'soft-light'", pill, v-b-tooltip="'Casos cerrados hoy'") {{ today_closed_cases }}
            b-col(cols="auto")
              b-dropdown(size="sm", no-caret, :variant="adminStatus.variant", v-b-tooltip="adminStatus.title")
                template(#button-content)
                  component(:is="adminStatus.icon")
                b-dropdown-item(v-for="(status, index) in admin_statuses", :key="index", @click="setAdminStatus(status)") {{ status.title }}
        b-card-header
          b-form-row.align-items-center.mb-2.justify-content-end
            b-col(v-if="groups_access")
              b-link.text-sm(v-b-toggle="'groups_section'")
                span.when-open Grupos
                span.when-closed {{group_name}}
                chevron-down-icon.ml-1.icon-md
            b-col(cols="auto", v-if="resources_access")
              b-button(v-if="device && hasVoip", size="sm", variant="soft-secondary", @click="openDial = !openDial").mr-1
                phone-call-icon.icon-sm
              b-dropdown#parent_drop(size="sm", variant="light", no-caret)
                template(slot="button-content")
                  more-vertical-icon.icon-sm
                //b-dropdown-item(@click="case_summary_modal = true", v-if="$can('read', 'inbox-resources')")
                  activity-icon.mr-2.icon-sm
                  span Resumen de casos
                b-dropdown-item(:to="{name: 'Resources'}", v-if="$can('read', 'inbox-resources')")
                  sliders-icon.mr-2.icon-sm
                  span Administrar recursos
                b-dropdown-item(@click="create_user_modal = true", v-if="has_whats_official && $can('create', 'whatsapp-user')")
                  v-icon.icon.text-success.mr-2(name="brands/whatsapp" )
                  span Nuevo usuario de Whatsapp
          b-collapse.my-2.overflow-y.scrollable-area#groups_section(visible, @shown="toggleGroupList(true)", @hidden="toggleGroupList(false)", v-if="groups_access", style="max-height: 120px;")
            b-link.nav-link.account-link.py-1(v-for="group of group_list", :key="group.group_id + counter", :class="{'router-link-active router-link-exact-active' : selected_group_id === group.group_id}", @click="$store.commit('inbox_filters/setGroupId', group.group_id)")
              .d-flex.justify-content-between.align-items-center
                div {{ group.name }}
                .d-flex.align-items-center
                  b-badge.mr-2(:variant="group.onHoldCasesCount > 0 ? 'primary' : 'soft-light'", pill, v-b-tooltip="'En espera'") {{ group.onHoldCasesCount }}
                  b-badge.mr-2(:variant="group.openCasesCount > 0 ? 'success' : 'soft-light'", pill, v-b-tooltip="'Abiertos'") {{ group.openCasesCount }}
                  //chevron-right-icon
          .text-center(v-if="loading_groups")
            b-spinner.my-4(variant="primary" )
          div(v-show="groups_access ? selected_group_id != null : true")
            inbox-filters.mb-1(for-cases)
            b-row.align-items-center(v-if="$can('read', 'list-bulk-edit')")
              b-col
                b-form-checkbox(:indeterminate="indeterminate", :checked="allChecked", @change="toggleAllSelected", :disabled="!cases.length")
              b-col(cols="auto")
                CaseActions(:selected_count="selected_cases.length", @click="updateCases", @canShow="handleCanShowCallHistory")
        .text-center.m-0(v-if="getShowCallCounting", :style="{ backgroundColor: '#52B366', color: 'white' }")
          span Llamada en curso: {{ callCounter }}
        .align-items-center.d-flex.flex-column.justify-content-center.h-100(v-if="(firstLoad || (selected_group_id == null && groups_access) || !cases.length) && !canShowCallHistory")
          b-spinner.my-4(v-if="firstLoad", variant="primary" )
          EmptyMessage(v-else-if="selected_group_id == null && groups_access", message="Selecciona un grupo para mostrar sus casos")
          EmptyMessage(v-else-if="!cases.length", message="No hay casos disponibles")
        #cases-rows.overflow-hidden.overflow-y.scrollable-area.h-100(v-show="groups_access ? selected_group_id != null : true")
          b-tabs(v-if="canShowCallHistory", small, card, fill)
            b-tab(title="Todos")
              EmptyMessage(v-if="!callHistory.length", message="No hay historial de llamadas")
              CallRow(v-if="callHistory.length", v-for="(call, index) in callHistory", :key="index", v-bind="call", :index="index", :selectedIndex="selectedIndex", v-model="selected_calls", @click="handleCallClick")
          CaseRow(v-if="!canShowCallHistory", v-for="(_case, index) in cases", :key="index", v-bind="_case", v-model="selected_cases", @click="case_id = $event")
        .text-center.my-2(v-if="loading_cases && cases.length")
          b-spinner(type="grow", variant="primary")
        //.pl-3(v-if="v_paginationShow")
          small.font-italic.text-secondary(v-if="cases.length") Mostrando {{cases.length}} de {{total_cases}}
          .d-flex.align-items-center.mb-3(:class="{'mt-2': !cases.length}")
            b-pagination.mb-0.mr-3(size="sm", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'requestCases')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount")
            b-spinner(small, variant="primary", v-if="loading_cases")
    b-col.h-100.d-none.d-lg-block(lg="8")
      b-card.card-inactive.text-center.h-100.d-flex.flex-column.justify-content-center(no-body, v-if="!case_id")
        EmptyMessage(message="Selecciona un caso")
      b-row.justify-content-end
        Dial(v-if="openDial", :device="device", :token="token").h-100.index
      b-row(v-if="isSomeoneCalling").zIndex.justify-content-end
        b-card(no-body, text-variant="white").receiveCall.d-flex.justify-content-center.align-items-center
          div.d-flex.align-items-center.mt-3
            div.mb-2
              b-avatar(size="md", :text="'N'", variant="soft-secondary")
            div.ml-3.flex-column.justify-content-start
              span {{ fromNumber || 'Número desconocido' }}
              p.text Llamada entrante
          div.my-3
            b-button(@click="rejectDirectly", :style="{ backgroundColor: '#FF4D4F' }").m-2.buttonStyle
              x-icon(stroke='white', fill='white').icon-sm
            b-button(@click="connect", :style="{ backgroundColor: '#52B366' }").m-2.buttonStyle
              phone-icon(fill="white", stroke="none").icon-sm
      router-view(:key="case_id", v-if="case_id && $breakpoint.lgUp")
    b-modal(v-model="create_user_modal", title="Crear usuario en Whatsapp", ok-only, ok-title='Cancelar', ok-variant="secondary",)
      send-whatsapp-template(user_id="new", @sent="create_user_modal = false")
    b-modal(v-model="case_summary_modal", size="lg", centered, title="Resumen de casos atendidos", hide-footer)
      b-container.overflow-md-y.scrollable-area(style="max-height: calc(90vh - 100px);")
        b-row.d-flex.mb-2.p-0
          b-col.d-flex.flex-column
            b-form-group(label="Total de casos")
              b-table(:items="statusData" :fields="statusFields"  borderless small fixed)
                template(v-slot:cell(status)="{ item }")
                  b-badge.mr-2(:variant="statusVariant(item.status)") {{ statuses[item.status] }}
                template(v-slot:cell(count)="{ item }")
                  b-badge.mr-3(:variant="statusVariant(item.status)", pill v-b-tooltip="statuses[item.status]") {{ item.count }}
                  b-badge(variant="secondary", pill v-b-tooltip="'Porcentaje'") {{getStatusPercentage(item.status,statusData)}}
          b-col.d-flex.flex-column
            b-form-group(label="Tiempo sin respuesta")
              b-table(:items="noAnswersData" :fields="statusFields"  borderless small fixed)
                template(v-slot:cell(status)="{ item }")
                  b-badge.mr-2(:variant="statusTimeVariant(item.status)") {{ statusTime[item.status] }}
                template(v-slot:cell(count)="{ item }")
                  b-badge.mr-3(:variant="statusTimeVariant(item.status)", pill v-b-tooltip="`${item.status} porcentaje`") {{ item.count }}
                  b-badge(variant="secondary", pill v-b-tooltip="`${item.status} porcentaje`") {{getStatusPercentage(item.status,noAnswersData)}}
        cases-summary()
    SideModal(v-model="side_modal_case", size="lg", @input="$router.push({name: 'Cases'}).then(() => {})")
      template(v-if="side_modal_case")
        router-view.full-height(:key="case_id")
</template>

<script>
import { EventBus } from '@/helpers/eventBus'
import { debounce } from 'lodash'
import { createNamespacedHelpers, mapActions } from 'vuex'
import CaseActions from '../../components/CaseActions'
import CaseRow from '../../components/CaseRow'
import CallRow from '../../components/CallRow'
import CasesSummary from '../../components/CasesSummary'
import InboxFilters from '../../components/InboxFilters'
import SendWhatsappTemplate from '../../components/SendWhatsappTemplate'
import { TimeChild, timeObserver } from '../../helpers/timeObserver'
import mixpanel from '@/mixpanel'
import Dial from '../../components/Dial'
import { Caller } from '../../helpers/caller'
import _ from 'lodash'

const adminController = createNamespacedHelpers('admin')
const accountController = createNamespacedHelpers('account')
const groupController = createNamespacedHelpers('group')
const tagController = createNamespacedHelpers('tag')
const filtersController = createNamespacedHelpers('inbox_filters')
const platformController = createNamespacedHelpers('platform')

export default {
  name: 'Cases',
  data() {
    return {
      fromNumber: '',
      selectedIndex: null,
      isSomeoneCalling: false,
      call: null,
      device: null,
      token: '',
      totalSeconds: 0,
      openDial: false,
      caller: null,
      adminEmail: '',
      callCounter: '',
      intervalId: null,
      canShowCallHistory: false,
      callHistory: [],
      selected_calls: [],
      socket: null,
      loading_groups: false,
      loading_cases: false,
      side_modal_case: false,
      create_user_modal: false,
      case_summary_modal: false,
      case_id: null,
      unreadOpenCases: 0,
      unreadOnHoldCases: 0,
      counter: 0,
      timeCounter: '',
      selected_cases: [],
      admin_statuses: [
        {
          title: 'Disponible',
          variant: 'success',
          icon: 'check-circle-icon',
          value: 'available'
        },
        {
          title: 'Pausa administrativa',
          variant: 'soft-primary',
          icon: 'clock-icon',
          value: 'backoffice'
        },
        {
          title: 'Descanso',
          variant: 'light',
          icon: 'coffee-icon',
          value: 'break'
        },
        {
          title: 'Desconectado',
          variant: 'soft-secondary',
          icon: 'power-icon',
          value: 'offline'
        }
      ],
      statuses: {
        open: 'Abierto',
        onHold: 'En espera',
        close: 'Cerrado'
      },
      statusTime: {
        lessThree: '< 3 min',
        overThree: '> 3 min',
        overFifteen: '> 15 min'
      },
      general_group: {
        group_id: 0,
        name: 'General',
        onHoldCasesCount: 0,
        openCasesCount: 0
      },
      statusFields: [
        { key: 'status', label: '' },
        { key: 'count', label: '' }
      ],
      noAnswersData: [
        { status: 'lessThree', count: 0 },
        { status: 'overThree', count: 0 },
        { status: 'overFifteen', count: 0 }
      ],
      statusData: [
        { status: 'open', count: 0 },
        { status: 'onHold', count: 0 },
        { status: 'close', count: 0 }
      ],
      timeWatcher: new TimeChild(timeObserver),
      durations: []
    }
  },
  inject: {
    caseSocket: {
      default: Object
    }
  },
  computed: {
    ...filtersController.mapState({
      selected_group_id: (state) => state.selected_group_id,
      search_text: (state) => state.search_text,
      dates: (state) => state.dates,
      labels: (state) => state.labels
    }),
    ...filtersController.mapGetters([
      'adminsIds',
      'platformsNames',
      'unreadValue',
      'outboundValue',
      'tagsIds',
      'statusValues'
    ]),
    ...accountController.mapGetters([
      'getFromNumber'
    ]),
    ...adminController.mapState({
      admin: (state) => state.admin
    }),
    ...adminController.mapGetters([
      'today_attending_cases',
      'today_closed_cases',
      'adminAccountStatus'
    ]),
    //...groupController.mapGetters(['total_cases']),
    ...groupController.mapState({
      groups: state => state.groups,
      cases: ({ cases }) => {
        return Object.values(cases).sort((a, b) => new Date(b.last_message_time) - new Date(a.last_message_time))
        //const sortedKeys = Object.keys(cases).sort((a, b) => b - a)
        //return sortedKeys.map(key => cases[key])
      }
    }),
    ...tagController.mapState({
      tags: (state) => state.tags
    }),
    ...accountController.mapState({
      force_case_tag: (state) => state.account_configuration.force_case_tag
    }),
    ...platformController.mapState({
      platforms: (state) => state.platforms
    }),
    ...accountController.mapGetters(['getShowCallCounting']),
    adminStatus() {
      const status = this.admin_statuses.find(s => s.value === this.adminAccountStatus)
      if (status) return status

      return {
        title: 'Desconectado',
        variant: 'soft-secondary',
        icon: 'power-icon',
        value: 'default'
      }
    },
    filters() {
      return {
        admin_ids: this.adminsIds,
        platform: this.platformsNames.length ? this.platformsNames : 'all',
        read: this.unreadValue ? 0 : undefined,
        outbound: this.outboundValue ? 1 : undefined,
        status: this.statusValues.length ? this.statusValues : 'open',
        ...this.dates,
        tag_ids: this.tagsIds || null
      }
    },
    group_list() {
      return [this.general_group, ...this.groups]
    },
    group_name() {
      if (!this.selected_group_id) return 'Grupos'

      const group = this.group_list.find(
        (element) => element.group_id === this.selected_group_id
      )

      return group ? group.name : 'Grupos'
    },
    groupOpenCasesCount() {
      const group = this.group_list.find(element => element.group_id === this.selected_group_id)

      return group ? group.openCasesCount : 0
    },
    indeterminate() {
      if (this.selected_cases.length && this.cases.length) {
        return this.cases.length > this.selected_cases.length
      }
      return false
    },
    allChecked() {
      if (this.selected_cases.length && this.cases.length) {
        return this.cases.length === this.selected_cases.length
      }
      return false
    },
    groups_access() {
      return this.$can('read', 'case-group') || this.$can('read', 'self-group-cases')
    },
    has_whats_official() {
      return this.platforms.find((el) => el.name === 'whatsapp_official')
    },
    resources_access() {
      return (
        this.$can('read', 'inbox-resources') ||
        (this.has_whats_official && this.$can('create', 'whatsapp-user'))
      )
    },
    hasVoip() {
      return this.platforms.find(({ name }) => name === 'voip')
    },
    firstLoad() {
      return this.loading_cases && !this.cases.length
    }
  },
  methods: {
    ...mapActions([
      'account/get_configuration',
      'account/get',
      'platform/all',
      'account/getHistoryCall',
      'admin/countTodayCases',
      'admin/getStatus',
      'admin/setStatus',
      'group/all',
      'admin/groups',
      'group/cases',
      'admin/cases',
      'inbox/searchCases',
      'group/countCasesByGroups',
      'case/update',
      'case/derivate',
      'case/assign',
      'account/getCaseIdFromCall',
      'admin/get',
      'case/get',
      'case/tags'
    ]),
    handleCallClick({ case_id: caseId, index }) {
      this.case_id = caseId

      this.selectedIndex = index
    },
    handleCanShowCallHistory(event) {
      this.canShowCallHistory = event
    },
    getAccountPlatforms() {
      const self = this

      this['platform/all']({
        account_id: self.$route.params.account_id,
        callback: async (res) => {
          if (res.error) return self.$message.error(res.error)

          if(!this.hasVoip) return

          this.adminEmail = self.getCurrentUser().email
          this.token = await this.generateAccessToken(this.adminEmail)

          if (this.$route.path.includes('cases')) {
            await this.caller.createAndRegisterDevice(this.token)
          }

          EventBus.$emit('putCaller', this.caller)
        }
      })
    },
    async generateAccessToken(name = '') {
      const params = { name }
      this.caller = new Caller(this)
      const token = await this.caller.getToken(params)

      EventBus.$emit('putToken', token)

      return token
    },
    async connect() {
      if (!this.call) return

      this.isSomeoneCalling = false

      await this.getCaseIdFromCall()
      this.call.accept()
    },
    rejectDirectly() {
      if (!this.call) return

      this.isSomeoneCalling = false

      this.call.accept()
      this.call.disconnect()
    },
    getHistoryCall() {
      const self = this

      this['account/getHistoryCall']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)

          this.callHistory = res.resource
        }
      })
    },
    async getCaseIdFromCall() {
      const self = this

      this['account/getCaseIdFromCall']({
        account_id: self.$route.params.account_id,
        call_id: self.call.parameters.CallSid,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)

          this.case_id = res.resource.caseId

          if (this.case_id) {
            this.$router.push({ name: 'Case', params: { case_id: this.case_id } }).catch(() => {})
          }
        }
      })
    },
    toggleGroupList(isOpen) {
      mixpanel.track(`Cases: Toggle Group List (${isOpen})`, {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      })
    },
    getConfiguration() {
      const self = this
      this['account/get_configuration']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    getAdminTodayCases() {
      const self = this
      this['admin/countTodayCases']({
        params: { account_id: self.$route.params.account_id },
        admin_id: self.getCurrentUser().admin_id,
        callback: res => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    getAdminStatus() {
      const self = this
      this['admin/getStatus']({
        params: {
          admin_id: self.getCurrentUser().admin_id,
          account_id: self.$route.params.account_id
        },
        callback: (res) => {
          if (res.error) return self.$message.info('Tu admin no esta asignado a esta cuenta')
        }
      })
    },
    setAdminStatus({ value }) {
      const self = this
      mixpanel.track(`Cases: Set Admin Status (${value})`, {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      })

      this['admin/setStatus']({
        admin_id: this.admin.admin_id,
        account_id: self.$route.params.account_id,
        status: value,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
          self.$message.success('Estado actualizado con éxito')
        }
      })
    },
    getGroups() {
      if (this.loading_cases) return

      const self = this
      this.loading_groups = true

      if (this.$can('read', 'show-all-groups')) {
        this['group/all']({
          account_id: self.$route.params.account_id,
          callback: (res) => {
            self.loading_groups = false

            if (res.error) return self.$message.error(res.error)

            try {
              this.updateGroupsCount()
            } catch (e) {
              console.log(e)
            }
          }
        })
      } else {
        this['admin/groups']({
          admin_id: self.getCurrentUser().admin_id,
          params: { account_id: self.$route.params.account_id },
          callback: (res) => {
            self.loading_groups = false

            if (res.error) return self.$message.error(res.error)

            try {
              this.updateGroupsCount()
            } catch (e) {
              console.log(e)
            }
          }
        })
      }
    },
    delayRefreshCases: debounce(
      function () {
        this.refreshCases()
      },
      300,
      { trailing: true, leading: false }
    ),
    refreshCases() {
      this.selected_cases = []

      this.resetPaginationData()
      this.requestCases()
      this.getAdminTodayCases()
    },
    requestCases() {
      if (this.search_text || !_.isEmpty(this.filters.tags)) return this.searchCases()
      if (this.$can('read', 'case-group')) return this.getGroupCases()
      if (this.$can('read', 'self-group-cases') && this.selected_group_id == null) return

      this.getAdminCases()
    },
    getAdminCases() {
      if (this.loading_cases) return

      const self = this
      this.loading_cases = true

      const params = {
        ...this.paginationParamsObject,
        ...this.filters,
        account_id: self.$route.params.account_id,
        group_id: self.selected_group_id
      }

      this['admin/cases']({
        params,
        admin_id: self.getCurrentUser().admin_id,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
          self.parsePaginationDataFromResponse(res)
          self.loading_cases = false
        }
      })
    },
    async getCase() {
      if (!this.$route.params.case_id) return

      const self = this

      this['case/get']({
        case_id: self.$route.params.case_id,
        params: { account_id: self.$route.params.account_id },
        soft: true,
        callback: async (res) => {
          if (res.error) return self.$message.error(res.error)

          this.$store.commit('group/setCaseTags', res.resource)
        }
      })
    },
    getGroupCases() {
      if (this.loading_cases || this.selected_group_id == null) return

      const self = this
      this.loading_cases = true

      const params = {
        ...this.paginationParamsObject,
        ...this.filters,
        account_id: self.$route.params.account_id
      }

      this['group/cases']({
        params,
        group_id: self.selected_group_id,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
          self.parsePaginationDataFromResponse(res)
          self.$nextTick(() => {
            self.loading_cases = false
          })
        }
      })
    },
    searchCases() {
      const self = this
      this.loading_cases = true

      mixpanel.track(`Cases: Search Cases`, {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      })

      const params = {
        ...this.paginationParamsObject,
        ...this.filters,
        text: this.search_text
      }
      if (this.selected_group_id) {
        params.group_id = this.selected_group_id
      }

      this['inbox/searchCases']({
        params,
        account_id: self.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
          self.loading_cases = false
        }
      })
    },
    updateGroupsCount: function () {
      if (!this.groups_access) return

      const self = this
      const params = { group_ids: 'all', status: 'open,on_hold' }

      if (this.$can('read', 'self-group-cases')) {
        params.admin_id = self.getCurrentUser().admin_id
      }

      this['group/countCasesByGroups']({
        account_id: self.$route.params.account_id,
        params,
        callback: (res) => {
          if (res.success) {
            this.counter++

            for (const element of res.resource) {
              if (!element.group_id) {
                this.general_group.openCasesCount = element.open || 0
                this.general_group.onHoldCasesCount = element.on_hold || 0
              } else {
                const group = this.groups.find(
                  (group) => group.group_id === element.group_id
                )

                if (group) {
                  group.openCasesCount = element.open || 0
                  group.onHoldCasesCount = element.on_hold || 0
                }
              }
            }
          }
        }
      })
    },
    toggleAllSelected(checked) {
      mixpanel.track(`Cases: Toggle All Selected (${checked.length})`, {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      })
      this.selected_cases = checked
        ? this.cases.map((el) => {
            return { case_id: el.case_id }
          })
        : []
    },
    updateCases(event) {
      const self = this

      mixpanel.track(`Cases: Update Cases (${event.action})`, {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      })

      let unclosed = 0

      for (let j = 0; j < this.selected_cases.length; j++) {
        const _case = this.selected_cases[j]

        if (
          this.force_case_tag &&
          event.action === 'case/update' &&
          event.data.status === 'close'
        ) {
          const caseObject = this.cases.find(
            (el) => el.case_id === _case.case_id
          )
          if (
            (caseObject && caseObject.Tags && !caseObject.Tags.length) ||
            (caseObject && !caseObject.Tags)
          ) {
            unclosed++
            continue
          }
        }
        if (event.action) {
          try {
            this[event.action]({
              case_id: _case.case_id,
              ...event.data,
              callback: (res) => {
                if (res.error) return self.$message.error(res.error)
              }
            })
          } catch (e) {
            console.log(e)
          }
        }
      }

      this.selected_cases = []

      if (unclosed > 0) {
        self.$message.warning(
          'Algunos casos no cuentan con etiquetas y no fueron cerrados.'
        )
      }
    },
    getStatusPercentage(status, statuses) {
      const currentStatus = statuses.find((el) => el.status === status)
      const totalStatus = statuses.reduce((acc, cur) => acc + cur.count, 0)
      const percentage = currentStatus
        ? (currentStatus.count / totalStatus) * 100
        : 0
      if (isNaN(percentage)) return '0.00%'
      return `${percentage.toFixed(2)}%`
    },
    statusVariant(status) {
      const variant = {
        open: 'soft-success',
        onHold: 'soft-primary',
        close: 'soft-danger'
      }
      return variant[status] || 'soft-secondary'
    },
    statusTimeVariant(status) {
      const variant = {
        lessThree: 'soft-success',
        overThree: 'soft-warning',
        overFifteen: 'soft-danger'
      }
      return variant[status] || 'soft-secondary'
    },
    updateTimeStatus(statusTime) {
      const threeMin = 60 * 3
      const fifteenMin = 60 * 15
      const total = statusTime.map(Number).reduce(
        (acc, curr) => {
          let duration = ''
          if (curr <= threeMin) duration = 'lessThree'
          else if (curr > threeMin && curr <= fifteenMin) duration = 'overThree'
          else duration = 'overFifteen'
          acc[duration]++
          return acc
        },
        { lessThree: 0, overThree: 0, overFifteen: 0 }
      )
      this.noAnswersData = Object.entries(total).map(([key, value]) => ({
        status: key,
        count: value
      }))
    },
    catchDurations({ open = [] } = { open: [] }) {
      let total = [...open.durations]
      this.durations = total
      this.timeWatcher.setDates(total)
      this.timeWatcher.update()
      total = this.timeWatcher.getTimes()
      this.updateTimeStatus(total)
    },
    catchStatus(statuses) {
      this.statusData = Object.keys(statuses).map((status) => ({
        status,
        count: statuses[status].count
      }))
    },
    connectSocket() {
      try {
        const { account_id: account } = this.$route.params
        if (!this.caseSocket) return
        if (!this.caseSocket.isConnected) return
        console.log(
          '%c Connecting to socket with account:',
          'color:#00aaf0',
          account
        )
        this.caseSocket.emit('setAccount', account)
        this.caseSocket.emit('casesStats', { account })
        this.caseSocket.on('reloadFilters', () => {
          // this.caseSocket.emit('casesStats', { account })
        })

        this.caseSocket.on('casesStats', (data) => {
          this.catchStatus(data)
          this.catchDurations(data)
        })
      } catch (e) {
        console.error(e)
      }
    },
    getCasesStats({ account_id: account, admin_assigned_id: admin }) {
      this.caseSocket.emit('casesStats', { account })

      if (admin) EventBus.$emit('updateAdmins')
    },
    stopCounter() {
      EventBus.$emit('pleaseStopCounter')
    },
    startCounter() {
      EventBus.$emit('pleaseStartCounter')
    },
  },
  mounted() {
    const self = this
    EventBus.$on('getSpecificTags', () => {
      setTimeout(() => { this.getCase() }, 500)
    })
    this.$store.commit('inbox_filters/setGroupId', null)
    this.getConfiguration()
    this.getAdminTodayCases()
    this.getAdminStatus()
    this.groups_access ? this.getGroups() : this.requestCases()
    this.updateGroupsCount()
    this.getHistoryCall()
    this.getAccountPlatforms()

    if (this.$route.name === 'Case' && this.$route.params.case_id) {
      this.case_id = this.$route.params.case_id
    }

    this.connectSocket()

    EventBus.$emit('updateCallUser')
    EventBus.$on('groups/count', () => {
      try {
        this.updateGroupsCount()
      } catch (e) {
        console.log(e)
      }
    })
    EventBus.$on('putOpenDial', (value) => { this.openDial = value })
    EventBus.$on('putFromNumber', (value) => { this.fromNumber = value })
    EventBus.$on('putCallCounter', (value) => { this.callCounter = value })
    EventBus.$on('time-update', () => {
      this.updateTimeStatus(this.timeWatcher.getTimes())
    })
    $('#cases-rows').on('scroll', function () {
      if (!self.v_paginationHasNextPage || self.loading_cases) return

      const top = $(this).scrollTop()
      if (top + this.clientHeight >= this.scrollHeight - 3) {
        self.requestCases()
      }
    })
  },
  unmounted() {
    this.caseSocket.off('casesStats')
  },
  watch: {
    call() {
      EventBus.$emit('putCall', this.call)
    },
    case_summary_modal(val) {
      if (!val) return

      mixpanel.track('Cases: Case Summary Modal', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      })
    },
    create_user_modal(val) {
      if (!val) return

      mixpanel.track('Cases: WhatsApp New User', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      })
    },
    selected_group_id(val) {
      if (val != null) this.refreshCases()
    },
    filters: {
      deep: true,
      handler: function () {
        this.refreshCases()
      }
    },
    search_text() {
      this.delayRefreshCases()
    },
    labels() {
      this.delayRefreshCases()
    },
    'admin.admin_id'(val) {
      if (val) this.getAdminStatus()
    },
    $breakpoint(value) {
      if (value.lgUp) {
        this.side_modal_case = false
      }

      if (
        value.mdDown &&
        this.$route.name === 'Case' &&
        this.$route.params.case_id
      ) {
        this.side_modal_case = true
      }
    },
    $route(value) {
      this.side_modal_case =
        value.name === 'Case' && value.params.case_id && this.$breakpoint.mdDown
    }
  },
  components: {
    InboxFilters,
    CaseRow,
    CallRow,
    CaseActions,
    SendWhatsappTemplate,
    CasesSummary,
    Dial
  }
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
.receiveCall {
  z-index: 999;
  width: 250px;
  position: absolute;
  top: 10px;
  right: 25px;
  font-size: 15px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  background-color: rgba(48, 49, 53, 0.95);
}
.zIndex {
  z-index: 999;
  position: absolute;
  top: 80px;
  right: 20px;
}

.text {
  font-size: 12px;
  font-weight: lighter;
}

.buttonStyle {
  border-radius: 200px;
  height: 40px;
  width: 40px;
  border: none;
}
.index {
  z-index: 999;
  position: absolute;
  margin-right: 30px;
  top: 100px;
}
</style>
